(function lawBookModuleDefinition() {
    'use strict';

    angular.module('LawBook', ['ui.router', 'ui.bootstrap.carousel', 'Config', 'Entities', 'ErrorsExtend', 'dndLists', 'UnitOrgComboControl', 'UnitOrgControl', 'AuthExtend', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function userConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('lawbook-find', {
                    url: '/LawBook/Find',
                    templateUrl: config.resourceUrl('/views/lawbook/lawbook-find.html'),
                    controller: 'LawBookFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('LAWBOOK READ').or('LAWBOOK WRITE')
                });

                $stateProvider.state('lawbook-detail', {
                    url: '/LawBook/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/lawbook/lawbook-detail.html'),
                    controller: 'LawBookDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('LAWBOOK READ').or('LAWBOOK WRITE')
                });

                $stateProvider.state('lawbook-add', {
                    url: '/LawBook/Add',
                    templateUrl: config.resourceUrl('/views/lawbook/lawbook-add-edit.html'),
                    controller: 'LawBookAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('LAWBOOK WRITE')
                });

                $stateProvider.state('lawbook-sign', {
                    url: '/LawBook/Sign/{id}',
                    templateUrl: config.resourceUrl('/views/lawbook/lawbook-sign.html'),
                    controller: 'LawBookSignController',
                    authorize: true,
                    roles: loginProvider.roleCondition('LAWBOOK SIGN')
                });

                $stateProvider.state('lawbook-massive-sign', {
                    url: "/LawBook/MassiveSign",
                    templateUrl: config.resourceUrl('/views/lawbook/lawbook-massive-sign.html'),
                    controller: 'LawBookMassiveSignController',
                    authorize: true,
                    roles: loginProvider.roleCondition('LAWBOOK SIGN')
                });

                $stateProvider.state('lawbook-edit', {
                    url: '/LawBook/Edit/{id}',
                    templateUrl: config.resourceUrl('/views/lawbook/lawbook-add-edit.html'),
                    controller: 'LawBookEditController',
                    authorize: true,
                    roles: loginProvider.roleCondition('LAWBOOK WRITE')
                });
            }
        ]);
})();